/**
 * The shop's own WhatsApp number, for pages that have to send a customer back
 * to the conversation.
 *
 * Configured rather than fetched. The screen that needs it most is the one
 * whose link has expired — there is no order to read and no valid token to
 * read it with, so an API round trip has nothing to answer with.
 */

// Digits only, with the country code and no '+', which is the form wa.me
// takes: 919876543210. Anything else in the value is stripped rather than
// rejected, because '+91 98765 43210' is how a person writes it into .env.
const NUMBER = String(import.meta.env.VITE_SHOP_WHATSAPP ?? '').replace(/\D/g, '')

/** Whether a number is configured at all. */
export const hasWhatsApp = () => NUMBER.length > 0

/**
 * A wa.me link that opens the chat with the message already typed.
 *
 * Returns null when no number is set, so a caller renders plain text instead
 * of a button that goes nowhere — a dead link on an error screen is worse
 * than no link, because it costs the customer a tap to discover it.
 */
export function waLink(text = '') {
  if (!NUMBER) return null
  return text
    ? `https://wa.me/${NUMBER}?text=${encodeURIComponent(text)}`
    : `https://wa.me/${NUMBER}`
}
